(() => {
  const registerCollectionFeaturedPopupDialog = () => {
    if (customElements.get('collection-featured-popup-dialog')) return;

    const ModalDialogBase = customElements.get('modal-dialog');
    if (!ModalDialogBase) return;

    class CollectionFeaturedPopupDialog extends ModalDialogBase {
      constructor() {
        super();
        this.collectionPopupTransitionToken = 0;
        this.collectionPopupTransitionTimer = null;
      }

      show(opener) {
        if (this.hasAttribute('open')) return;

        this.openedBy = opener;
        const panel = this.querySelector('.collection-featured-popup__content');
        const popup = this.querySelector('.template-popup');
        const transitionToken = ++this.collectionPopupTransitionToken;

        window.clearTimeout(this.collectionPopupTransitionTimer);
        if (window.BrilintonSurfaceManager) {
          this.surfaceName = this.surfaceName || `modal:${this.id || this.dataset.section || 'dialog'}`;
          window.BrilintonSurfaceManager.register(this.surfaceName, { root: () => this, close: () => this.hide() });
          window.BrilintonSurfaceManager.open(this.surfaceName, { trigger: opener, lockMode: 'overflow' });
        } else {
          document.body.classList.add('overflow-hidden');
        }
        this.classList.remove('is-closing', 'is-opening', 'is-open', 'is-animating', 'is-visible');
        panel?.getAnimations?.().forEach((animation) => animation.cancel());

        // Match ProductFaqDialog exactly: commit the closed transform before
        // [open] is exposed, then release it and enter on the next frame.
        if (panel) {
          panel.style.setProperty('transition', 'none', 'important');
          panel.style.setProperty('transform', 'var(--popup-closed-transform)', 'important');
        }

        this.setAttribute('open', '');
        if (popup) popup.loadContent();

        if (panel) panel.getBoundingClientRect();

        window.requestAnimationFrame(() => {
          if (transitionToken !== this.collectionPopupTransitionToken || !this.hasAttribute('open')) return;

          if (panel) {
            panel.style.removeProperty('transition');
            panel.style.removeProperty('transform');
            panel.getBoundingClientRect();
          }

          this.classList.add('is-open', 'is-visible');
          trapFocus(this, this.querySelector('[role="dialog"]'));
          window.pauseAllMedia();
        });
      }

      hide() {
        if (!this.hasAttribute('open')) return;

        const panel = this.querySelector('.collection-featured-popup__content');
        const transitionToken = ++this.collectionPopupTransitionToken;
        let didClose = false;

        window.clearTimeout(this.collectionPopupTransitionTimer);

        const finishClosing = (event) => {
          if (didClose || transitionToken !== this.collectionPopupTransitionToken) return;
          if (event && (event.target !== panel || event.propertyName !== 'transform')) return;

          didClose = true;
          panel?.removeEventListener('transitionend', finishClosing);
          panel?.style.removeProperty('transition');
          panel?.style.removeProperty('transform');
          if (window.BrilintonSurfaceManager && this.surfaceName) {
            removeTrapFocus();
            window.BrilintonSurfaceManager.close(this.surfaceName, { restoreFocus: true });
          } else {
            document.body.classList.remove('overflow-hidden');
            removeTrapFocus(this.openedBy);
          }
          document.body.dispatchEvent(new CustomEvent('modalClosed'));
          this.removeAttribute('open');
          this.classList.remove('is-closing', 'is-opening', 'is-open', 'is-animating', 'is-visible');
          window.pauseAllMedia();
        };

        this.classList.remove('is-visible', 'is-open', 'is-opening');
        this.classList.add('is-closing');

        if (panel) panel.addEventListener('transitionend', finishClosing);
        this.collectionPopupTransitionTimer = window.setTimeout(finishClosing, 460);
      }
    }

    customElements.define('collection-featured-popup-dialog', CollectionFeaturedPopupDialog);
  };

  if (customElements.get('modal-dialog')) registerCollectionFeaturedPopupDialog();
  else customElements.whenDefined('modal-dialog').then(registerCollectionFeaturedPopupDialog);
})();
